import React from 'react';
import { Card, Descriptions, Tag, Spin, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useStaffDetail } from '../../hooks/useStaffs';

const StaffDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { staff, loading } = useStaffDetail(id || '');

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!staff) return <Card>Không tìm thấy nhân viên.</Card>;

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/staffs')}>
        Quay lại danh sách
      </Button>
      <Card title={`Nhân viên · ${staff.name}`}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Họ tên">{staff.name}</Descriptions.Item>
          <Descriptions.Item label="Username">{staff.username}</Descriptions.Item>
          <Descriptions.Item label="Email">{staff.email}</Descriptions.Item>
          <Descriptions.Item label="SĐT">{staff.phone || '—'}</Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={staff.state === 1 ? 'success' : 'default'}>
              {staff.state === 1 ? 'Hoạt động' : 'Tạm khoá'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="2FA">
            <Tag color={staff.two_fa_enabled ? 'blue' : 'default'}>{staff.two_fa_enabled ? 'Bật' : 'Tắt'}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Tenant ID" span={2}>
            <code>{staff.tenant_id || '—'}</code>
          </Descriptions.Item>
          <Descriptions.Item label="Department ID" span={2}>
            <code>{staff.department_id || '—'}</code>
          </Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {staff.created_at ? dayjs(staff.created_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Cập nhật">
            {staff.updated_at ? dayjs(staff.updated_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default StaffDetail;
export { StaffDetail };
